import { render } from "./otp2.vue?vue&type=template&id=1db0d98f&scoped=true"
import script from "./otp2.vue?vue&type=script&lang=js"
export * from "./otp2.vue?vue&type=script&lang=js"

import "./otp2.vue?vue&type=style&index=0&id=1db0d98f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db0d98f"]])

export default __exports__